export default {
  sessionStatus: {
    PENDING: "In Bearbeitung",
    CONFIRMED: "Bestätigt",
    EXPIRED: "Abgelaufen",
    CANCELLED: "Storniert",
  },
  messageStatus: {
    DELIVERED: "Zugestellt",
    BLOCKED: "Blockiert",
  },
  sender: {
    CUSTOMER: "Kunde",
    SELLER: "Verkäufer",
    ADMIN: "Staff",
    SYSTEM: "System",
  },
  channel: {
    WHATSAPP: "WhatsApp",
    SMS: "SMS",
    EMAIL: "E-Mail",
  },
  messageInput: {
    send: "Senden",
  },
  bubble: {
    agreementDetected: "Vereinbarung erkannt",
  },
  audit: {
    blockReason: "Blockierungsgrund",
    gptAnalysis: "Analyse-Metadaten",
    sent: "Gesendet",
    notSent: "Nicht gesendet",
    internalNote: "Intern (nicht an Kunden gesendet)",
    viaChannel: "über {{channel}}",
  },
  listItem: {
    agreementReached: "✅ Vereinbarung erzielt",
  },
  filters: {
    allSellers: "Alle Verkäufer",
    panelTitle: "Filter",
    clearAll: "Alle zurücksetzen",
    status: "Status",
    channel: "Kanal",
    customerName: "Kundenname",
    customerNamePlaceholder: "Nach Kundenname suchen…",
    dateRange: "Datumsbereich",
    from: "Von",
    to: "Bis",
    seller: "Verkäufer",
    clear: "Zurücksetzen",
    search: "Suchen",
  },
} as const;
